import { render, staticRenderFns } from "./exportData1.vue?vue&type=template&id=5393c21b&scoped=true"
import script from "./exportData1.vue?vue&type=script&lang=js"
export * from "./exportData1.vue?vue&type=script&lang=js"
import style0 from "./exportData1.vue?vue&type=style&index=0&id=5393c21b&prod&lang=scss"
import style1 from "./exportData1.vue?vue&type=style&index=1&id=5393c21b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5393c21b",
  null
  
)

export default component.exports